import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RouteErrorBoundary } from "./components/RouteErrorBoundary";
import { StandaloneLayout } from "./components/StandaloneLayout";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ConversationDetailPage } from "./pages/content/ConversationDetailPage";
import { ConversationsPage } from "./pages/content/ConversationsPage";
import { DeliveriesPage } from "./pages/content/DeliveriesPage";
import { StorageOrphanAuditPage } from "./pages/content/StorageOrphanAuditPage";
import { StoragePage } from "./pages/content/StoragePage";
import { SummaryJobsPage } from "./pages/content/SummaryJobsPage";
import { AgentDetailPage } from "./pages/governance/AgentDetailPage";
import { AgentListingReviewsPage } from "./pages/governance/AgentListingReviewsPage";
import { AgentsPage } from "./pages/governance/AgentsPage";
import { AuditPage } from "./pages/governance/AuditPage";
import { BlocksPage } from "./pages/governance/BlocksPage";
import { GrantsPage } from "./pages/governance/GrantsPage";
import { RelationsPage } from "./pages/governance/RelationsPage";
import { SpaceReportsPage } from "./pages/governance/SpaceReportsPage";
import { IntegrationsPage } from "./pages/integrations/IntegrationsPage";
import { ApplicationsPage } from "./pages/invites/ApplicationsPage";
import { InviteCodesPage } from "./pages/invites/InviteCodesPage";
import { MetricsLayout } from "./pages/metrics/MetricsLayout";
import { BillingPage } from "./pages/revenue/BillingPage";
import { BackendApiCoveragePage } from "./pages/system/BackendApiCoveragePage";
import { BackendApiTestsPage } from "./pages/system/BackendApiTestsPage";
import { CloudCostsPage } from "./pages/system/CloudCostsPage";
import { CommunicationsPage } from "./pages/system/CommunicationsPage";
import { CrashesPage } from "./pages/system/CrashesPage";
import { DlqPage } from "./pages/system/DlqPage";
import { HealthPage } from "./pages/system/HealthPage";
import { UserDetailPage } from "./pages/users/UserDetailPage";
import { UserListPage } from "./pages/users/UserListPage";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/system/backend-api-tests",
    element: <StandaloneLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        element: <BackendApiTestsPage />,
      },
      {
        path: "file/:filePath",
        element: <BackendApiTestsPage />,
      },
    ],
  },
  {
    path: "/",
    element: <Layout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "users",
        element: <UserListPage />,
      },
      {
        path: "users/:id",
        element: <UserDetailPage />,
      },
      {
        path: "metrics",
        element: <MetricsLayout />,
      },
      {
        path: "integrations",
        element: <IntegrationsPage />,
      },
      {
        path: "content/conversations",
        element: <ConversationsPage />,
      },
      {
        path: "content/conversations/:id",
        element: <ConversationDetailPage />,
      },
      {
        path: "content/storage",
        element: <StoragePage />,
      },
      {
        path: "content/storage/orphan-audit",
        element: <StorageOrphanAuditPage />,
      },
      {
        path: "content/summary-jobs",
        element: <SummaryJobsPage />,
      },
      {
        path: "content/deliveries",
        element: <DeliveriesPage />,
      },
      {
        path: "revenue/billing",
        element: <BillingPage />,
      },
      {
        path: "governance/relations",
        element: <RelationsPage />,
      },
      {
        path: "governance/blocks",
        element: <BlocksPage />,
      },
      {
        path: "governance/agents",
        element: <AgentsPage />,
      },
      {
        path: "governance/agent-reviews",
        element: <AgentListingReviewsPage />,
      },
      {
        path: "governance/agents/:id",
        element: <AgentDetailPage />,
      },
      {
        path: "governance/grants",
        element: <GrantsPage />,
      },
      {
        path: "governance/audit",
        element: <AuditPage />,
      },
      {
        path: "governance/space-reports",
        element: <SpaceReportsPage />,
      },
      {
        path: "system/cloud-costs",
        element: <CloudCostsPage />,
      },
      {
        path: "system/health",
        element: <HealthPage />,
      },
      {
        path: "system/communications",
        element: <CommunicationsPage />,
      },
      {
        path: "system/dlq",
        element: <DlqPage />,
      },
      {
        path: "system/crashes",
        element: <CrashesPage />,
      },
      {
        path: "system/backend-api-coverage",
        element: <BackendApiCoveragePage />,
      },
      {
        path: "system/backend-api-coverage/:slug",
        element: <BackendApiCoveragePage />,
      },
      {
        path: "invites/applications",
        element: <ApplicationsPage />,
      },
      {
        path: "invites/codes",
        element: <InviteCodesPage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);
